<template>
  <div class="page-wrap">
    <div class="box-wrap">
      <div class="search-wrap">
        <search-bar @enter="SearchFn"></search-bar>
      </div>
    </div>

    <nav>
      <ul @click="selectNave">
        <li
          v-for="(item, index) in barList"
          :key="item.name"
          :class="index == activeIndex ? 'active' : ''"
          :data-index="index"
        >
          {{ item.name }}
        </li>
      </ul>
    </nav>
    <div class="select-bar">
      <select-component
        :dataList="list1"
        @change="formTypeFn"
        title="形式"
      ></select-component>
      <select-component
        :dataList="list2"
        @change="ageGroupFn"
        :multiple="true"
        title="年龄段"
      ></select-component>
      <!-- <select-component
        :dataList="list3"
        @change="territoryFn"
        title="地域"
      ></select-component> -->
      <select-province @change="provinceFn" title="地域"></select-province>
      <select-component
        :dataList="list4"
        @change="chargeTypeFn"
        title="收费类型"
      ></select-component>
    </div>
    <div class="content-wrap">
      <div
        class="section-wrap"
        v-for="(list, key) in barList"
        :key="key"
        v-show="key == activeIndex"
      >
        <div v-show="list.list.length > 0">
          <section v-for="item in list.list" :key="item._id">
            <div class="img-wrap">
              <router-link
                :to="'/detail?type=' + item.slefType + '&id=' + item._id"
              >
                <img v-show="item.tempFileURL" :src="item.tempFileURL" alt="" />
              </router-link>
            </div>
            <div class="section-content">
              <router-link
                :to="'/detail?type=' + item.slefType + '&id=' + item._id"
              >
                <div class="section-title">{{ item.Name }}</div>
              </router-link>
              <div>
                <div class="section-tags" v-html="getAges(item)"></div>
                <div class="section-museum">{{ item.Owner }}</div>
              </div>
            </div>
          </section>
        </div>
        <loading
          @getMore="loadingFn"
          :loading="list.loading"
          :isMore="list.isMore"
          :hide="true"
        ></loading>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "../components/SearchBar";
import Loading from "../components/Loading";
import SelectComponent from "../components/SelectComponent.vue";
import SelectProvince from "../components/SelectProvince.vue";
import { getIndexInfoList } from "../util/util";
export default {
  components: {
    SearchBar,
    SelectComponent,
    SelectProvince,
    Loading,
  },
  computed() {},
  data() {
    return {
      list1: [
        { label: 0, value: "不限" },
        { label: 1, value: "线路" },
        { label: 2, value: "课程" },
      ],
      list2: [
        { label: 1, value: "小学1~3年级" },
        { label: 2, value: "小学4~6年级" },
        { label: 3, value: "中学" },
        { label: 4, value: "高中" },
      ],
      list3: [{ label: 1, value: "测试3" }],
      list4: [
        { label: 0, value: "不限" },
        { label: 1, value: "付费" },
        { label: 2, value: "免费" },
      ],
      // value: "测试1",
      formType: "",
      ageGroup: "",
      territory: "",
      chargeType: "",
      barList: [
        {
          name: "全部",
          list: [],
          page: 0,
          falg: false,
          loading: true,
          isMore: true,
        },
        {
          name: "历史类",
          list: [],
          page: 0,
          falg: false,
          loading: true,
          isMore: true,
        },
        {
          name: "红色类",
          list: [],
          page: 0,
          falg: false,
          loading: true,
          isMore: true,
        },
        {
          name: "自然类",
          list: [],
          page: 0,
          falg: false,
          loading: true,
          isMore: true,
        },
        {
          name: "科技类",
          list: [],
          page: 0,
          falg: false,
          loading: true,
          isMore: true,
        },
        {
          name: "民族民俗类",
          list: [],
          page: 0,
          falg: false,
          loading: true,
          isMore: true,
        },
        {
          name: "艺术类",
          list: [],
          page: 0,
          falg: false,
          loading: true,
          isMore: true,
        },
      ],
      className: "全部",
      activeIndex: 0,
      SearchName: "",
    };
  },
  mounted() {
    var intersectionObserver = new IntersectionObserver((entries) => {
      // 如果不可见，就返回
      console.log(entries[0].intersectionRatio);
      if (
        entries[0].intersectionRatio <= 0 ||
        entries[0].intersectionRatio == 1
      )
        return;
      this.getListInfo();
      /* console.log("Loaded new items"); */
    });
    // 开始观察
    document.querySelectorAll(".loading").forEach((item) => {
      intersectionObserver.observe(item);
    });
  },
  created() {
    const index = this.$route.query.type;
    this.activeIndex = index;
    this.className = this.barList[index].name;
    this.getListInfo();
  },
  methods: {
    getAges(item) {
      let str = `<span class="tag">${
        item.slefType == "Roads" ? "线路" : "课程"
      }</span><span class="tag">${item.Class}</span>`;
      item.Age.split(",").map((age) => {
        str += `<span class="tag">${age}</span>`;
      });
      return str;
    },
    // 获取所有路线
    getAllRoads(params = {}) {
      const db = this.$TCB_App.database();
      const AllRoads = db.collection("DataBase_All_Roads");
      return AllRoads.orderBy("EditDate", "desc")
        .skip(this.$data.barList[this.activeIndex].page)
        .where(params)
        .get();
    },
    // 获取所有课程
    getAllCourse(params = {}) {
      const db = this.$TCB_App.database();
      const AllCourse = db.collection("DataBase_All_Course");
      return AllCourse.orderBy("EditDate", "desc")
        .skip(this.$data.barList[this.activeIndex].page)
        .where(params)
        .get();
    },
    SearchFn(val) {
      this.resetSearchFn();
      this.SearchName = val;
    },
    resetSearchFn() {
      this.barList[this.activeIndex].falg = false;
      this.barList[this.activeIndex].loading = true;
      this.barList[this.activeIndex].isMore = true;
      this.barList[this.activeIndex].page = 0;
      this.barList[this.activeIndex].list = [];
      this.getListInfo();
    },
    // 形式
    formTypeFn(params) {
      console.log(params);
      this.formType = params.value == "不限" ? "" : params.value;
      this.resetSearchFn();
    },
    // 年龄段
    ageGroupFn(params) {
      this.ageGroup =
        params.length == 0
          ? ""
          : params.map((item) => {
              return item.value;
            });
      this.resetSearchFn();
    },
    // 区域
    territoryFn(params) {
      console.log(params);
      this.territory = params.value;
      this.resetSearchFn();
    },
    provinceFn(params) {
      if (params == "地域" || params == '全部省份') {
        this.territory = "";
      }else if (params.indexOf("市") > -1) {
        this.territory = params.substring(0,params.indexOf("市"));
      } else {
        this.territory = params;
      }
      this.resetSearchFn();
    },
    // 收费类型
    chargeTypeFn(params) {
      console.log(params);
      this.chargeType = params.value == "不限" ? "" : params.value;
      this.resetSearchFn();
    },
    loadingFn() {},
    getListInfo() {
      let where = {};
      if (this.className != "全部") {
        where = {
          Class: this.className,
        };
      }
      // 搜索
      // if (this.SearchName != "") {
      //   where.Name = this.SearchName;
      //   // where = Object.assign(where, { Name: this.SearchName });
      // }
      // 区域
      if (this.territory != "") {
        where.Province = this.territory;
      }
      // 收费类型
      if (this.chargeType != "") {
        where.Prices = this.chargeType;
      }
      if (this.barList[this.activeIndex].falg) return;
      getIndexInfoList({
        $TCB_App: this.$TCB_App,
        limit: 20,
        where: where,
        skip: this.barList[this.activeIndex].page,
      }).then((res) => {
        let list = [];
        // 根据筛选条件展示不同的内容，因为这里用的是两个库比较坑
        if (this.formType == "") {
          list = res.flat(Infinity);
        } else if (this.formType == "线路") {
          // 路线
          list = res[0];
        } else {
          // 课程
          list = res[1];
        }

        if (list.length > 0) {
          // 根据年龄段匹配 过滤list
          if (this.ageGroup != "") {
            list = list.filter((item) => {
              // 遍历年龄段

              const ages = this.ageGroup.find((val) => {
                console.log(item.Age, val);
                return item.Age.indexOf(val) > -1;
              });
              console.log(ages);
              console.log(ages != undefined);
              return ages != undefined;
            });
          }
          const currentList = this.barList[this.activeIndex].list;
          this.barList[this.activeIndex].list = currentList.concat(list);
          var newList = []
          if(this.SearchName){
            this.barList[this.activeIndex].list.map((item)=>{
              item.Name.includes(this.SearchName)?newList.push(item):''
            })
            console.log(newList)
            this.barList[this.activeIndex].list = newList
          }
          this.barList[this.activeIndex].page += 20;
          
        }
        if (list.length < 20) {
          this.barList[this.activeIndex].falg = true;
          this.barList[this.activeIndex].loading = false;
          this.barList[this.activeIndex].isMore = false;
        }
      });
    },
    selectNave(e) {
      const halfW = document.body.clientWidth/2
      if(e.clientX > halfW){
        document.querySelector('nav').scrollLeft = e.clientX - halfW
      }else{
        document.querySelector('nav').scrollLeft = 0
      }
      const index = e.target.getAttribute("data-index");
      const className = e.target.innerText;
      console.log(index,className)
      this.className = className;
      //if (index) {
        this.activeIndex = index;
        this.loading = this.barList[index].list.length >= 0;
      //}
      this.resetSearchFn();
    },
  },
};
</script>

<style scoped lang="scss">
.page-wrap {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #faf9f9;
}
.box-wrap {
  padding: 2.667vw 4vw;
  background: #ffffff;
  .search-wrap {
    background: #fafafa;
    height: 9.333vw;
    border-radius: 8vw;
  }
}
nav {
  margin-top: 2.667vw;
  background: #ffffff;
  overflow-x: scroll;
  border-bottom: solid 0.133vw #eeeeee;
  ul {
    display: inline-block;
    padding: 0 4vw;
    margin: 0;
    white-space: nowrap;
    li {
      display: inline-block;
      list-style-type: none;
      text-align: center;
      height: 13.333vw;
      line-height: 13.333vw;
      font-size: 4vw;
      color: #7288a6;
    }
    li.active {
      font-size: 4.533vw;
      font-weight: bold;
      color: #111111;
      position: relative;
    }
    li:nth-child(n + 2) {
      margin-left: 5.867vw;
    }
    li.active::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 0.667vw;
      background: #71a209;
    }
  }
}
.select-bar {
  height: 12vw;
  background: #ffffff;
  border-bottom: solid 0.133vw #eeeeee;
  display: flex;
  justify-content: space-between;
  > div {
    flex: 1;
    flex-shrink: 0;
  }
}
.section-wrap {
  background: #ffffff;
  section {
    display: flex;
    padding: 4.667vw 5.333vw;
    box-sizing: border-box;
    a {
      display: inline-block;
      text-decoration: none;
    }
    .img-wrap {
      width: 34.667vw;
      height: 26vw;
      border-radius: 0.8vw;
      flex-shrink: 0;
      overflow: hidden;
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }
}
.section-content {
  margin-left: 2.667vw;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .section-title {
    font-size: 4.533vw;
    color: #111111;
    font-weight: bold;
  }

  .section-museum {
    font-size: 3.467vw;
    color: #7288a6;
    margin-top: 2.667vw;
  }
}
.section-tags {
  font-size: 3.2vw;
  color: #ffffff;
  span {
    padding: 0.8vw 1.333vw;
    display: inline-block;
    border-radius: 0.533vw;
    margin-right: 2vw;
  }
  span:nth-child(1) {
    background: #7cb6f3;
  }
  span:nth-child(2) {
    background: #e8b585;
  }
  span:nth-child(3) {
    background: #95a7ff;
  }
  span:nth-child(4) {
    background: #85e8a0;
  }
  span:last-child {
    margin-right: 0;
  }
}
.tip {
  font-size: 3.467vw;
  color: #9b9b9b;
  text-align: center;
  padding: 5.333vw 0 12vw 0;
}
.content-wrap {
  height: calc(100% - 43.2vw);
  overflow-y: scroll;
}
</style>
<style lang="scss">
.section-tags {
  font-size: 3.2vw;
  color: #ffffff;
  span {
    padding: 0.8vw 1.333vw;
    display: inline-block;
    border-radius: 0.533vw;
    margin-right: 2vw;
    margin-bottom: 1vw;
  }
  span:nth-child(1) {
    background: #7cb6f3;
  }
  span:nth-child(2) {
    background: #e8b585;
  }
  span:nth-child(3) {
    background: #95a7ff;
  }
  span:nth-child(4) {
    background: #85e8a0;
  }
  span:nth-child(5) {
    background: #7cb6f3;
  }
  span:nth-child(6) {
    background: #e8b585;
  }
  span:nth-child(7) {
    background: #95a7ff;
  }
  span:last-child {
    margin-right: 0;
  }
}
</style>